import React from 'react';
import { cn } from '../lib/utils';
import type { LucideIcon } from 'lucide-react';

interface PremiumPageHeaderProps {
  title: string;
  subtitle?: string | React.ReactNode;
  icon: LucideIcon;
  /** @deprecated no longer used */
  gradientClassName?: string;
  /** Custom classes for the icon container backdrop */
  iconContainerClassName?: string;
  /** Custom classes for the icon itself */
  iconClassName?: string;
  children?: React.ReactNode;
  className?: string;
}

export const PremiumPageHeader: React.FC<PremiumPageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  iconContainerClassName = 'bg-primary/10 border-primary/20',
  iconClassName = 'text-primary',
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-2',
        className
      )}
    >
      <div className="flex items-center gap-3">
        {/* Icon */}
        <div
          className={cn(
            'h-10 w-10 rounded-xl border flex items-center justify-center shrink-0',
            iconContainerClassName
          )}
        >
          <Icon className={cn('h-5 w-5', iconClassName)} />
        </div>

        <div>
          <h1 className="text-xl md:text-2xl font-black text-foreground tracking-tight leading-tight break-words">
            {title}
          </h1>
          {subtitle && (
            <div className="text-sm text-muted-foreground font-medium mt-0.5 leading-snug">
              {subtitle}
            </div>
          )}
        </div>
      </div>

      {children && <div className="flex flex-wrap items-center gap-3 shrink-0">{children}</div>}
    </div>
  );
};
